import { Typography } from '../typography'
import { Spinner } from './spinner'

import { CodeExample } from '../demo/code-example'
import { DemoTabs } from '../demo/demo-tabs'

export const SpinnerDemo = () => {
  return (
    <div className="space-y-2">
      <Typography variant="cf-title-01" className="text-cf-grey-900">
        Spinner
      </Typography>

      <DemoTabs
        tabs={{
          preview: (
            <>
              <div className="space-y-6">
                <div className="border-cf-grey-100 rounded-lg border p-6">
                  <div className="space-y-4">
                    <div>
                      <Typography variant="cf-heading-01">
                        The default variation of the spinner has a purple to white gradient
                      </Typography>
                      <div className="flex items-center p-4 justify-center mt-4">
                        <Spinner />
                      </div>
                      <CodeExample
                        code={`import { Spinner } from '@repo/design-system-cf/components/spinner'

// Default spinner
<Spinner />`}
                      />
                    </div>
                  </div>
                </div>

                <div className="border-cf-grey-100 rounded-lg border p-6 bg-cf-blue-900">
                  <div className="space-y-4 ">
                    <div>
                      <Typography className="text-cf-grey-50" variant="cf-heading-01">
                        On colored backgrounds
                      </Typography>
                      <div className="flex items-center p-4 justify-center mt-4">
                        <Spinner variant="inverse" />
                      </div>
                      <CodeExample
                        code={`import { Spinner } from '@repo/design-system-cf/components/spinner'

// Transparent to white variant (for colored backgrounds)
<Spinner variant="inverse" />`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ),
          api: {
            properties: [
              {
                name: 'className',
                type: 'string',
                defaultValue: 'undefined',
                description:
                  'Additional CSS classes to apply. Can be used for custom sizing and colors.',
              },
              {
                name: 'variant',
                type: "'default' | 'inverse'",
                defaultValue: "'default'",
                description:
                  'Visual variant of the spinner. Default uses purple-to-white gradient, inverse uses inverse gradient.',
              },
            ],
          },
          changelog: [
            {
              date: '23-06-2025',
              changes: [
                "Renamed variant from 'transparent-to-white' to 'inverse' for better naming consistency.",
              ],
            },
            {
              date: '11-06-2025',
              changes: [
                'Added variant prop with inverse option.',
                'Updated component to support different color schemes.',
              ],
            },
            {
              date: '11-06-2025',
              changes: [
                'Initial spinner component with CF-Purple gradient design.',
                'Implemented smooth rotation animation using CSS animate-spin.',
                'Added SVG-based design with linear gradient for consistent branding.',
              ],
            },
          ],
          design: (
            <iframe
              style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}
              width="100%"
              height="100%"
              src="https://embed.figma.com/design/c8oXlEODLmj3csp3ux5DKu/Design-System---Components?node-id=875-702&m=dev&embed-host=share"
              allowFullScreen
            />
          ),
        }}
      />
    </div>
  )
}
